import React, { useState } from "react";
import { TextField } from "@mui/material";
import "./CommentForm.scss";

interface ICommentFormProps {
    onCommentChange: (payload: { body: string; username?: string }) => void;
}

const CommentForm: React.FC<ICommentFormProps> = ({ onCommentChange }) => {
    // Generate a random guest name between 1 and 999
    const generateRandomGuestName = () =>
        `Guest${Math.floor(Math.random() * 999) + 1}`;

    const [anonymousUsername, setAnonymousUsername] = useState(
        generateRandomGuestName
    );
    const [commentValue, setCommentValue] = useState("");
    // This state controls whether the textarea is expanded
    const [expanded, setExpanded] = useState(false);

    const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setCommentValue(value);
        // If there is text, keep the field expanded.
        if (value.trim() !== "") {
            setExpanded(true);
        }
        onCommentChange({
            body: value,
            username: anonymousUsername || undefined,
        });
    };

    const handleAnonymousUsernameChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const username = e.target.value;
        setAnonymousUsername(username);
        onCommentChange({
            body: commentValue,
            username: username || undefined,
        });
    };

    // Expand on focus
    const handleFocus = () => {
        setExpanded(true);
    };

    // Collapse on blur only if the comment is empty
    const handleBlur = () => {
        if (!commentValue.trim()) {
            setExpanded(false);
        }
    };

    return (
        <div className="form-wrapper">
            <form className="comment-box">
                <TextField
                    label="Author"
                    variant="filled"
                    className="comment-textfield"
                    value={anonymousUsername}
                    placeholder="Add your name"
                    onChange={handleAnonymousUsernameChange}
                    multiline
                    size="small"
                    margin="normal"
                    fullWidth
                />
                <TextField
                    id="comment"
                    label="Comment"
                    variant="filled"
                    className="comment-field"
                    value={commentValue}
                    onChange={handleOnChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    multiline
                    fullWidth
                    margin="normal"
                    placeholder="Comment on this Tendbe"
                    // Setting rows ensures Material‑UI does not auto-resize (and add inline styles)
                    rows={1}
                    // Pass our custom class to the underlying textarea.
                    inputProps={{
                        className: expanded
                            ? "custom-textarea expanded"
                            : "custom-textarea",
                    }}
                />
            </form>
        </div>
    );
};

export default CommentForm;
